import { Button, IconButton, TextField } from '@material-ui/core'
import { useFormik } from 'formik'
import { Box } from 'reoil'
import {AwardInfoItem} from '../../hooks/api/useFechResume'
import { SubTitle } from '../../pages/UserResumeEditPage'
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { useThemeValue } from '../../store/themeState'
import { rgba } from 'polished'
import { MdAdd, MdDelete } from 'react-icons/md'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import dateUtils from '@date-io/dayjs'
import localZh from 'dayjs/locale/zh'
import UploadFile from './UploadFile'
import React from 'react'


interface AwardInfoListProps {
  awardInfoList: AwardInfoItem[]
  onBlur: (values:AwardInfoItem[])=>void
}

const AwardInfoList: React.FC<AwardInfoListProps> = ({awardInfoList=[], onBlur}) => {
  const theme = useThemeValue()

  const formik = useFormik({
    initialValues: awardInfoList,
    validate: values=>{
      onBlur(values)
    },
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: values=>{

    }
  })

  const handleClickAdd = ()=> {
    formik.setValues(values=>values.concat({
      name: '',
      finisheddate: '',
      type: '',
      publishingOffice: '',
      link: '',
      file: '',
      userid: '',
      sort: ''
    }))
  }

  const handleClickClose = (index: number)=>{
    formik.setFormikState(form=>{
      delete form.values[index]

      return {
        ...form,
        values: form.values.filter(item=>item)
      }
    })
  }

  return (
    <MuiPickersUtilsProvider utils={dateUtils} locale={localZh}>
      <Box
        className='AwardInfoList'
        stretch
        mb={3}
        css={css`
          .series span {
            transform-origin: left top;
            transform: scale(3.6);
          }
          .field {
            margin-bottom: 8px;
          }
        `}>
        <SubTitle xuantian>作品代表</SubTitle>

        {formik.values && formik.values.map((item, i) => (
          <Box
            className='part'
            key={i}
            border='divider'
            borderRadius={8}
            p={2}
            mb={3}
            stretch>
            <Box
              className='series'
              fontWeight='bold'
              fontSize={1}
              color={rgba(theme.colors.primary, 0.16)}
              mb={1}>
              <span>{i+1}</span>
            </Box>
            <Box position='absolute' style={{zIndex: 2}} right={0} onClick={()=>handleClickClose(i)}><IconButton className="close"><MdDelete/></IconButton></Box>
            <TextField className='field' label='作品名称' name={`[${i}].name`} value={item.name||''} onChange={formik.handleChange} onBlur={formik.handleBlur} />
            <DatePicker className='field' label='完成日期' cancelLabel='取消' openTo='year' okLabel='确定' format='YYYY-MM-DD' name={`[${i}].finisheddate`} value={item.finisheddate||null} onChange={(date)=>formik.setFieldValue(`[${i}].finisheddate`, date?.format('YYYY-MM-DD'))} onBlur={formik.handleBlur} />
            <TextField className='field' label='作品类型' name={`[${i}].type`} value={item.type||''} onChange={formik.handleChange} onBlur={formik.handleBlur} />
            <TextField className='field' label='刊发处' multiline name={`[${i}].publishingOffice`} value={item.publishingOffice||''} onChange={formik.handleChange} onBlur={formik.handleBlur} />
            <TextField className='field' label='作品链接地址' name={`[${i}].link`} value={item.link||''} onChange={formik.handleChange} onBlur={formik.handleBlur} />
            {/* <TextField className='field' label='作品附件上传' name={`[${i}].file`} value={item.file||''} onChange={formik.handleChange} onBlur={formik.handleBlur} /> */}
            <UploadFile initialFilename={item.file} onChange={response=>{
              formik.setFieldValue(`[${i}].file`, response.publishUrl)
              // formik.setFieldValue(`[${i}].fileLink`, response.publishUrl)
              formik.validateForm()
            }} />
          </Box>
        ))}

        <Button variant='contained' onClick={handleClickAdd}><MdAdd size={20} />新增</Button>
      </Box>
    </MuiPickersUtilsProvider>
  )
}


export default AwardInfoList
